"use strict";

import User from "./user";
import BaseModel from "@/shared/lib/client-sdk/base-model";

class EntityChangeLog extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "EntityChangeLog";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/change-logs"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create change logs directly.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    console.error("Cannot update change logs directly.");
  }

  getAdminPath() {
    console.error("Cannot go to an entity change log.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.user.searchResultTitle();
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return this.TableName + ":" + this.recordUuid;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }

  // If the API returns a relationship as a sub-object, this tells the base model which class to use for them when it laods it in.
  get relationships() {
    return { user: User };
  }
}

export default EntityChangeLog;
